import React from "react";

export const MainHeading: React.FC = ({ children }) => (
  <>
    <h2 className="text-2xl text-red-500 mb-1">{children}</h2>
    <hr className="block w-8 h-1 bg-red-500 border-none mb-4" />
  </>
);
